import { CodeBook, DocumentData } from "@king-ict/eupisi-ui/models";

export interface AndragogicLeader {
  id: number,
  oib: string,
  firstName: string,
  lastName: string,
  dateFrom?: Date,
  dateTo?: Date,
  address: string,
  institutionLocationTypeId: number,
  institutionLocationTypeName: string,
  activityState: AndragogicLeaderState;
  deleteState: AndragogicLeaderDeleteState;
  copyOdDiploma?: DocumentData;
  additionalDocument?: DocumentData;
  locations: CodeBook[];
  deactivateDate?: Date;
  oibChecked: boolean;
}

export enum AndragogicLeaderState {
  Active = 1,
  Deactivating = 2,
  Deactivated = 3
}

export enum AndragogicLeaderDeleteState {
  None = 0,
  CannotDelete = 1,
  Deleted = 2
}

export const AndragogicLeaderInitial = (): AndragogicLeader => {
  return {
    id: 0,
    oib: "",
    firstName: "",
    lastName: "",
    dateFrom: new Date(),
    dateTo: new Date(),
    address: "",
    institutionLocationTypeId: 0,
    institutionLocationTypeName: "",
    activityState: AndragogicLeaderState.Active,
    deleteState: AndragogicLeaderDeleteState.None,
    copyOdDiploma: undefined,
    additionalDocument: undefined,
    locations: [],
    deactivateDate: undefined,
    oibChecked: false
  }
}